import React, { useRef, useState } from 'react';
import { fireGAEvent } from '@/analytics';
import SearchIcon from '@/icons/SearchIcon';

import SearchBox from './SearchBox';

import './SearchButton.less';

export function SearchButton() {
    const [toggled, setToggled] = useState(false);
    const ref = useRef();

    function click(e) {
        e.stopPropagation();
        setToggled(!toggled);
        ref.current.focus();
        fireGAEvent('Tab menu', 'Search');
    }
    function close() {
        setToggled(!toggled);
    }
    return (
        <>
            <button className="search-button" onClick={click} aria-label="Vyhľadávanie" data-atid="main-menu-search">
                <SearchIcon />
            </button>

            <SearchBox ref={ref} visible={toggled} onClose={close} />
        </>
    );
}
